var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"close-btn",class:[`close-btn--${_vm.position}`],attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('base-icon',{staticClass:"close-btn__icon",attrs:{"name":"close-outline","width":"24","height":"24"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }